export var HeaderAlignments;

(function (HeaderAlignments) {
  HeaderAlignments["CENTER"] = "center";
  HeaderAlignments["LEFT"] = "left";
})(HeaderAlignments || (HeaderAlignments = {}));